<bit-dialog
  dialogSize="default"
  background="default"
  class="bv-confirm-dialog bv-rotate-encryption-key-dialog"
>
  <span bitDialogTitle class="tw-sr-only">{{ "rotateEncKeyTitle" | i18n }}</span>
  <div bitDialogContent class="bv-confirm-dialog__content">
    <div class="bv-confirm-dialog__icon" aria-hidden="true"></div>
    <h2 class="bv-confirm-dialog__title">{{ "rotateEncKeyTitle" | i18n }}</h2>
    <p class="bv-confirm-dialog__message">{{ message }}</p>
  </div>
  <ng-container bitDialogFooter>
    <div class="bv-confirm-dialog__footer">
      <button type="button" bitButton buttonType="secondary" (click)="close(false)">
        {{ "no" | i18n }}
      </button>
      <button type="button" bitButton buttonType="primary" (click)="close(true)">
        {{ "yes" | i18n }}
      </button>
    </div>
  </ng-container>
</bit-dialog>
